export const name = 'ks/user';

export const UPDATE = `${name}/update`;